export default __webpack_public_path__ + "static/media/environment.d746da28.svg";